<template>
  <div class="mc-modal" id="oneClickBuy" :class="{isOpen: isOpen}">
    <div class="mc-modal__outer">
      <div class="mc-modal__inner">
        <div class="mc-modal__heading">
          <button @click="$emit('close')" class="mc-modal__close-button js-button-close simulated-hover" type="button" aria-label="Закрыть">
            <svg class="mc-modal__close-icon" width="30" height="30" viewBox="0 0 30 30">
              <use xlink:href="/assets/svg/sprite.svg#icon-cross"></use>
            </svg>
          </button>
          <div class="mc-modal__title">
            {{submitStatus.success?submitStatus.message:'Забрать из магазина'}}
          </div>
        </div>
        <div v-if="!submitStatus.success" class="mc-modal__body">
          <form class="mc-form" @submit.prevent="submitForm" method="post" autocomplete="off">
            <div class="mc-form__body">
              <fieldset class="mc-form__fieldset">
                <div class="mc-form__field">
                  <label class="mc-form__label" for="oneClickBuyName">
                    Город
                    <span class="mc-form__asterisk">*</span>
                  </label>
                  <select class="mc-form__input" v-model="formData.city" required>
                  <option value="">Выбрать</option>
                  <option v-for="item in city" :value="item">{{item}}</option>
                </select>
                </div>
                <div class="mc-form__field">
                  <label class="mc-form__label" for="oneClickBuyName">
                    Магазин
                    <span class="mc-form__asterisk">*</span>
                  </label>
                  <select class="mc-form__input" v-model="formData.shop" required>
                    <option value="">Выбрать</option>
                    <option v-for="item in shop" :value="item.id">{{item.title}}</option>
                  </select>
                </div>
                <div class="mc-form__field">
                  <label class="mc-form__label" for="oneClickBuyName">
                    Имя и фамилия
                    <span class="mc-form__asterisk">*</span>
                  </label>
                  <input class="mc-form__input" id="oneClickBuyName" type="text" v-model="formData.name" placeholder="Ольга Иванова" required>
                </div>
                <div class="mc-form__field">
                  <label class="mc-form__label" for="oneClickBuyPhone">
                    Телефон
                    <span class="mc-form__asterisk">*</span>
                  </label>
                  <MaskInput class="mc-form__input" id="oneClickBuyPhone" type="tel" v-model="formData.phone" placeholder="+7 (___) ___-__-__" required mask="+7 (###) ###-##-##"  />
                </div>
              </fieldset>
              <p class="mc-form__notice mc-form__notice--centered">
                Нажимая на кнопку "Отправить", вы принимаете условия&nbsp;<router-link to="/page/oferta/">Публичной оферты</router-link>
              </p>
              <div v-if="submitStatus.message && submitStatus.error" class="mc-message mc-message--alert">
                        <span class="mc-message__content" v-html="submitStatus.message"></span>
              </div>
            </div>
            <div class="mc-form__bottom">
              <button class="mc-button mc-button--color simulated-hover" type="submit" :disabled="isSubmitting">
                                    <span class="mc-button__text">
                                        {{ isSubmitting ? 'Отправка...' : 'Отправить' }}
                                    </span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { MaskInput } from 'vue-3-mask';

export default {
  props: {
    isOpen: false,
    id: false,
    store: []
  },
  emits: ['close'],
  data() {
    return {
      formData: {
        name: '',
        phone: '',
        city: '',
        shop: '',
        product_id: this.id
      },
      isSubmitting: false,
      submitStatus: {
        error: false,
        success: false,
        message: ''
      }
    };
  },
  mounted() {
    this.submitStatus = { error: false, success: false, message: '' };
  },
  watch: {
    id(newVal) {
      this.formData.productId = newVal;
    }
  },
  computed: {
    city() {
      //debugger;
      if (!this.id || !this.store[this.id])
        return [];
      return Object.keys(this.store[this.id]);
    },
    shop() {
      //debugger;
      if (!this.city || !this.formData.city || !this.store[this.id][this.formData.city])
        return [];
      return this.store[this.id][this.formData.city];
    }
  },
  methods: {
    async submitForm() {
      this.isSubmitting = true;
      this.submitStatus = { error: false, status: false, message: '' };

      try {
        const response = await axios.post('api/catalog/order/', this.formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        if (response.data.status == 'success' && response.status === 200) {
          this.submitStatus.message = 'Ваш заказ №'+response.data.data.id+' принят. Мы свяжемся с вами';
          this.formData.name = '';
          this.formData.phone = '';
          this.formData.city = '';
          this.formData.shop = '';
          this.submitStatus.success = true;

          // Close the modal after successful submission with a short delay
          /*setTimeout(() => {
            this.$emit('close');
          }, 2000);*/
        } else {
          this.submitStatus.error = true;
          for (let i in response.data.errors)
            this.submitStatus.message += response.data.errors[i].message+'<br>';
        }
      } catch (error) {
        this.submitStatus.error = true;
        this.submitStatus.message = error.response?.data?.message ||
            'Произошла ошибка при отправке запроса. Пожалуйста, попробуйте позже.';
        console.error('Form submission error:', error);
      } finally {
        this.isSubmitting = false;
      }
    }
  },
  components: {MaskInput}
}
</script>